import { RouteType } from 'types/RouteType';
// import StandardProceduresIcon from '@mui/icons-material/FolderOpen';

const standardProceduresRoute: RouteType = {
  name: 'Standard Procedures',
  path: '/standard-procedures',
  layout: '/app',
  viewportCard: {
    header: {
      title: 'Standard Procedures',
      // component: () => import('./StandardProcedures.Header'),  // Add if a header component exists
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import('./StandardProcedures.Body'),
      // grayBackground: true, // Add if needed
    },
  },
  group: 'Administration',
  requiresAuth: true, // Assumed based on currentUser access in beforeEnter
  requiresPermission: false,
  channels: ['standard-procedures/file', 'user-subscription'],
  // beforeEnter: async ({ rootStore }) => {
  //   const {
  //     userSubscriptionStore: { find },
  //     authStore: { currentUser },
  //   } = rootStore;
  //   find({
  //     query: {
  //       userId: currentUser.id,
  //       type: 'standard-procedures',
  //       notificationType: 'email',
  //     },
  //   });
  // },
  // onEnter: async ({ rootStore }) => {
  //   const {
  //     standardProceduresViewStore: { refreshProcedures },
  //   } = rootStore;
  //   refreshProcedures();
  // },
  // onExit: async ({ rootStore, params, queryParams }) => {
  //   setTimeout(() => {
  //     if (queryParams?.tabName || queryParams?.subTab) {
  //       let actualQueryParams = queryParams;
  //       if (actualQueryParams.subTab) {
  //         delete actualQueryParams.subTab;
  //       }
  //       if (actualQueryParams.tabName) {
  //         delete actualQueryParams.tabName;
  //       }
  //       rootStore.routerStore.goTo(
  //         rootStore.routerStore.currentRoute,
  //         params,
  //         actualQueryParams
  //       );
  //     }
  //   }, 50);
  // },
  // onParamsChange: async ({ rootStore }) => {
  //   const {
  //     standardProceduresViewStore: { refreshProcedures },
  //   } = rootStore;
  //   refreshProcedures();
  // },
  defaultQueryParams: { tabName: 'General', subTab: 'All' }, // Added defaultQueryParams
  // icon: StandardProceduresIcon,  Icon, sidebarShortcut, homeShortcut and hidden properties are not part of the new RouteType, these should be handled separately in the sidebar/homescreen config.
  //
  //
  // hidden: false,
};

export default standardProceduresRoute;
